import { getRequest, postRequest } from "./ApiInstence";
import axios from "./axiosConfig";

// Get report settings
export const getReportSettingsApi = () =>
  getRequest("get/");

// Update report settings
export const updateReportSettingsApi = (data) =>
  postRequest("update/", data);

// Generate report manually
export const generateReportNowApi = () =>
  getRequest("generate-report/");

// Download report (PDF or Excel based on settings)
export const downloadReportApi = () =>
  axios.post("download/", {}, { 
    responseType: 'blob' // Important for file download
  });
